var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',[_c('transition-group',{attrs:{"name":"commentTransition","tag":"li"}},_vm._l((_vm.commentsCollection),function(comment){return _c('li',{key:comment.id,staticClass:"mb-6",class:{ 'ml-12' : !_vm.is_first }},[_c('comment',{attrs:{"language":_vm.language,"data":comment,"content_id":_vm.content_id}})],1)}),0)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }